module.exports = __webpack_public_path__ + "7b29c9626663fc0902d67be334186269.svg";